import React from 'react';
import './style.scss';
import PropTypes from "prop-types";
import {FormattedMessage} from 'react-intl';

export default class SenderDetails extends React.Component {
    static propTypes = {
        storeOrderId: PropTypes.string.isRequired,
        customerName: PropTypes.string.isRequired,
    };

  render() {
    return (
        <div className="SenderDetails">
          <div className="Title-text">{this.props.customerName}</div>
          <div className="Description-text">
              <span className="FirstField"><FormattedMessage
            id="GoSendPartner.OrderNo"
            /></span>
              <span className="SecondField">{this.props.storeOrderId}</span>
          </div>
        </div>
    );
  }
}

